import React from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

interface BankFilterProps {
  value?: string;
  onValueChange: (value: string | undefined) => void;
}

const BANKS = [
  { value: "all", label: "Todos los bancos" },
  { value: "NO_BANK", label: "Sin banco (Webpay, Efectivo, etc.)" },
  { value: "Banco Santander", label: "Banco Santander" },
  { value: "Banco Santander Chile", label: "Banco Santander Chile" },
  { value: "Banco de Chile", label: "Banco de Chile" },
  { value: "Banco Estado", label: "Banco Estado" },
  { value: "Banco Itaú", label: "Banco Itaú" },
  { value: "Banco Itaú Chile", label: "Banco Itaú Chile" },
  { value: "Banco de Crédito e Inversiones", label: "BCI" },
  { value: "BCI", label: "BCI (Abreviado)" },
  { value: "Banco BCI", label: "Banco BCI" },
  { value: "Scotiabank Chile", label: "Scotiabank Chile" },
  { value: "Banco Scotiabank", label: "Banco Scotiabank" },
  { value: "Banco Internacional", label: "Banco Internacional" },
  { value: "Banco Edwards Citi", label: "Banco Edwards Citi" },
  { value: "Banco Falabella", label: "Banco Falabella" },
  { value: "Banco Security", label: "Banco Security" },
  { value: "Banco BICE", label: "Banco BICE" },
];

const BankFilter: React.FC<BankFilterProps> = ({ value, onValueChange }) => {
  const handleValueChange = (newValue: string) => {
    if (newValue === "all") {
      onValueChange(undefined);
    } else {
      onValueChange(newValue);
    }
  };

  return (
    <div>
      <Select value={value || "all"} onValueChange={handleValueChange}>
        <SelectTrigger className="w-[220px]">
          <SelectValue placeholder="Seleccionar banco" />
        </SelectTrigger>
        <SelectContent>
          {BANKS.map((bank) => (
            <SelectItem key={bank.value} value={bank.value}>
              {bank.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default BankFilter;
